/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useMemo } from 'react';

interface OverlayViewportInsets {
  bottom: string;
}

interface OverlayViewportInsetsProviderProps {
  bottomInset: string | null;
  children: React.ReactNode;
}

const OverlayViewportInsetsContext = createContext<OverlayViewportInsets | null>(null);

export function OverlayViewportInsetsProvider({
  bottomInset,
  children,
}: OverlayViewportInsetsProviderProps) {
  const value = useMemo(() => (bottomInset ? { bottom: bottomInset } : null), [bottomInset]);

  return (
    <OverlayViewportInsetsContext.Provider value={value}>
      {children}
    </OverlayViewportInsetsContext.Provider>
  );
}

export function useOverlayViewportInsets(): OverlayViewportInsets | null {
  return useContext(OverlayViewportInsetsContext);
}

export function getOverlayViewportPaddingStyle(
  insets: OverlayViewportInsets | null,
  baseBottomPadding: string
): React.CSSProperties | undefined {
  if (!insets) {
    return undefined;
  }

  return {
    paddingBottom: `calc(${baseBottomPadding} + ${insets.bottom})`,
  };
}
